export const formatDouble = (value: number, digit = 0) => {
  if (value) {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: digit,
      maximumFractionDigits: digit,
    });
  }

  return '0.00';
};


export const roundUpPriceForDisplay = (price: number | string | undefined | null): string => {
  if (!price) return '0';
  
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;
  if (isNaN(numPrice)) return '0';
  
  // Round up to next whole dollar
  const rounded = Math.ceil(numPrice);
  
  // Format with thousands separators, no decimals
  return rounded.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

export const parsePositiveRate = (value: unknown): number | null => {
  const num = typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : NaN;
  return Number.isFinite(num) && num > 0 ? num : null;
};

export const formatPositiveRateOrDash = (value: unknown): string => {
  const num = parsePositiveRate(value);
  return num == null ? '-' : `$ ${formatDouble(num, 0)}`;
};
